// Copyright (c) 2017 Deere & Company

import actions from '../action-list';

const resetShowNoResultsFound = () => false;

const updateShowNoResultsFound = (state, action) => action.hasNoResult;

export default (state = false, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_MAINTENANCE_PLAN]: resetShowNoResultsFound,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SHOW_NO_RESULTS_FOUND]: updateShowNoResultsFound
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/show-no-results-found.js